import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";
import { getRequest } from "../../apiWrapper";

Modal.setAppElement("#root");

// 既読者一覧モーダル
const NotificationReadListModal = ({ notificationId, onClose }) => {
  const [readers, setReaders] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await getRequest(`notifications/reads/${notificationId}`);
        setReaders(res);
      } catch (err) {
        console.error("既読者取得エラー:", err);
      }
    })();
  }, [notificationId]);

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      className="max-w-md mx-auto mt-24 bg-white rounded-2xl shadow-lg p-6 relative"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
      >
        <FaTimes size={18} />
      </button>
      <h3 className="text-xl font-semibold mb-4">既読者一覧</h3>
      <div className="space-y-2 max-h-60 overflow-y-auto">
        {readers.length === 0 ? (
          <p className="text-gray-500">まだ誰も既読にしていません。</p>
        ) : (
          readers.map((r) => (
            <div
              key={r.userid}
              className="flex justify-between items-center border-b py-2"
            >
              <span>{r.teacher_name || r.userid}</span>
              <span className="text-sm text-gray-500">
                {new Date(r.read_at).toLocaleString()}
              </span>
            </div>
          ))
        )}
      </div>
      <div className="flex justify-end mt-4">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
        >
          閉じる
        </button>
      </div>
    </Modal>
  );
};

export default NotificationReadListModal